import SunCalc from 'suncalc';

const NYC = { lat: 40.7128, lng: -74.006 };

/** Map sun altitude (radians) to an ambient rgba tint string. */
export function altitudeToTint(altRad: number): string {
  // night: deep blue; twilight: warm gold; day: faint warm wash
  if (altRad < -0.1) return 'rgba(6, 10, 28, 0.55)';
  if (altRad < 0.1) return 'rgba(255, 150, 60, 0.30)'; // golden hour
  if (altRad < 0.4) return 'rgba(255, 200, 120, 0.16)';
  return 'rgba(255, 240, 210, 0.06)';
}

export interface DayNightController {
  stop: () => void;
  /** When disabled (light/satellite themes) the tint clears so the base map shows true. */
  setEnabled: (on: boolean) => void;
}

export function startDayNight(opts: {
  el: HTMLElement;
  nowMs: () => number;
  intervalMs?: number;
}): DayNightController {
  let enabled = true;
  const apply = () => {
    if (!enabled) {
      opts.el.style.background = 'transparent';
      return;
    }
    const alt = SunCalc.getPosition(new Date(opts.nowMs()), NYC.lat, NYC.lng).altitude;
    opts.el.style.background = altitudeToTint(alt);
  };
  apply();
  const id = setInterval(apply, opts.intervalMs ?? 60000);
  return {
    stop: () => clearInterval(id),
    setEnabled: (on: boolean) => {
      enabled = on;
      apply();
    },
  };
}
